import { mergeUserFavorites } from 'src/providers/FavoriteTripsContext/firestore.util';
import { LocalStorageFavoritesService } from 'src/providers/FavoriteTripsContext/LocalStorageFavoritesService';

export const moveFavoritesFromLocalStorageToFirebase = async (userId: string) => {
  const ls = new LocalStorageFavoritesService();
  const favorites = ls.loadFavorites();
  if (favorites) {
    await mergeUserFavorites(userId, favorites);
    ls.clearFavorites();
  }
};
